// extracted by mini-css-extract-plugin
export var circle = "_2k-2";
export var icon = "_2k-a";
export var iconHighlight = "_2k-0";
export var lg = "_2k-8";
export var md = "_2k-7";
export var outline = "_2k-4";
export var sm = "_2k-6";
export var square = "_2k-1";
export var xl = "_2k-9";
export var xs = "_2k-5";
export var xxs = "_2k-3";